module.exports = __webpack_public_path__ + "img/esg-3-4.11452a49.png";